import { environment } from 'src/environments/environment';
import { Component, Renderer2, OnInit, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { AnalyticsHelper } from 'src/app/helpers/analytics';
import { AnalyticsQueries } from 'src/app/model/constants';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as tsvParse from "d3-dsv";
import Swal from 'sweetalert2';
import { DomSanitizer, SafeValue } from '@angular/platform-browser';
import { processHide, processShow } from 'src/app/helpers/process';
import { Router } from '@angular/router';
import { authorize } from 'src/app/helpers/AuthorizePage';
import { dispatchDateSelectChange } from 'src/app/helpers/tracking';
import * as moment from 'moment';
declare let $: any;

const showError = (e) => {
  const { message } = JSON.parse(e.data);
  AnalyticsHelper.openSweetAlert(`<p class="line1">Important Notice</p><p class="line2">${message}</p>`, false);
}

@Component({
  selector: "app-analytics-table",
  templateUrl: "./analytics-table.component.html",
  styleUrls: ["./analytics-table.component.scss"]
})
export class AnalyticsTable implements OnInit {

  startDate: any;
  selectedDate: any;
  ready: boolean;
  checkedSummary: boolean;
  checkedReport: boolean;
  imageProcess: string;
  titleProcess: string;
  desProcess: string;
  percentageProcess: number;
  hasIssue: boolean;
  dailyReportUrl: SafeValue;
  dailyReportHistUrl: SafeValue;
  processReady: boolean;
  activeTab: string;
  setupMessageHandle: boolean;
  dataupdate: string;
  dailyDataSummary: any;
  dailyDataCCBJISalesByChannel: any;
  dailyDataCCBJISalesRetailCompany: any;
  dailyDataCCBJISalesFoodServiceCompany: any;
  dailyDataCCBJISalesRetailCompanyTotal: any;
  dailyDataCCBJISalesNationalSalesDivisionTotal: any;
  dailyDataCCBJISalesEastJapan: any;
  dailyDataCCBJISalesMetropolitan: any;
  dailyDataCCBJISalesKansaiChubu: any;
  dailyDataCCBJISalesKyushuChushikoku: any;
  dailyDataCCBJISalesRetailSalesDivisionTotal: any;
  dailyDataCCBJISalesEastJapanRetail: any;
  dailyDataCCBJISalesMetropolitanRetail: any;
  dailyDataCCBJISalesKansaiChubuRetail: any;
  dailyDataCCBJISalesKyushuChushikokuRetail: any;
  dailyDataCCBJISaleseCommerceSalesTotal: any;
  dailyDataCCBJISalesFSCompanyFSAreaSalesTotal: any;
  dailyDataCCBJISalesFSCompanyTotal: any;
  dailyDataCCBJISalesFSEastJapan: any;
  dailyDataCCBJISalesFSWestJapan: any;
  dailyDataCCBJISalesFSAreaOther: any;
  dailyDataCCBJISalesFSNationKamOther: any;
  periodDay: any;
  constructor(private router: Router, private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document, private http: HttpClient, private sanitizer: DomSanitizer) {

  }

  ngOnInit() {
    if (!authorize()) {
      this.router.navigateByUrl('unauthorized');
    }
    else {
      //let selectedDate = new Date();
      this.activeTab = localStorage.getItem('activeTab');
      if (this.activeTab == null || this.activeTab == 'Summary') {
        this.activeTab = '';
      }
      var yesterday = moment(new Date()).add(-1, 'day');

      let yesterday_format = yesterday.format('YYYYMMDD');

      let queryUrl = environment.hygraphGetJobUpdate;
      let httpOptions: Object = {
        headers: new HttpHeaders().append('Authorization', 'Bearer ' + localStorage.getItem('accessToken')),
        responseType: 'text'
      }
      this.http.get<any>(queryUrl, httpOptions)
        .subscribe(
          response => {
            let res = JSON.parse(response);
            if (res.data[environment.clearCacheJobStatus] != null && res.data[environment.clearCacheJobStatus].length > 0) {
              let latest_date = res.data[environment.clearCacheJobStatus][0].date;
              if (yesterday_format == latest_date) {
                this.dataupdate = 'true';
              }
              else {
                this.dataupdate = 'false';
              }
              let year = parseInt(latest_date.substring(0, 4));
              let month = parseInt(latest_date.substring(4, 6));
              let day = parseInt(latest_date.substring(6, 8));
              this.selectedDate = {
                year: year,
                month: month,
                day: day
              };
              this.startDate = {
                year: year,
                month: month,
                day: day
              };
            }

            let date = this.selectedDate.year + '-' + (this.selectedDate.month < 10 ? '0' + this.selectedDate.month : this.selectedDate.month)
              + '-' + (this.selectedDate.day < 10 ? '0' + this.selectedDate.day : this.selectedDate.day);
            this.loadReportSummary(date);
            this.periodDay = 'Period : as of ' + `${this.selectedDate.year}/${this.selectedDate.month}/${this.selectedDate.day}`;

            // this.dailyReportUrl = this.sanitizer.bypassSecurityTrustResourceUrl(environment.dailyReportUrl.replace('{0}', date).replace('{1}', localStorage.getItem('accessToken')).replace('{2}', this.activeTab));
            //this.dailyReportHistUrl = this.sanitizer.bypassSecurityTrustResourceUrl(environment.dailyReportHistUrl.replace('{0}', date).replace('{1}', localStorage.getItem('accessToken')).replace('{2}', this.activeTab).replace('{3}', this.dataupdate));
            // this.bindIconProcess();
            // FPT-TruongDV19 [2022/02/28] Disable scrollbar in daily report page.
            document.body.style.overflowY = 'hidden';
          },
          error => {
            console.log(error);
          }
        );



      // selectedDate.setDate(selectedDate.getDate() - 1);
      // if(localStorage.getItem('selectedDate') != null){
      //   var arr = localStorage.getItem('selectedDate').split(',');
      //   let year = parseInt(arr[0]);
      //   let month = parseInt(arr[1]);
      //   let date = parseInt(arr[2]);
      //   selectedDate = new Date(year,month,date);
      // }
      // this.startDate.setDate(this.startDate.getDate()-1);
      // if(this.startDate.getUTCHours() >= 15){
      //   this.startDate.setDate(this.startDate.getDate()-1);
      // }
      // if(this.startDate < selectedDate){
      //   selectedDate = this.startDate;
      //   let year = selectedDate.getFullYear();
      //   let month = selectedDate.getMonth();
      //   let date = selectedDate.getDate();         
      //   localStorage.setItem('selectedDate', year + ',' + month + ',' + date);
      // }
      // this.selectedDate = {
      //   year: selectedDate.getFullYear(),
      //   month: selectedDate.getMonth() +1,
      //   day: selectedDate.getDate()
      // };
    }

    window.addEventListener('message', showError);
  }

  ngOnDestroy() {
    document.body.style.overflowY = 'auto';

    window.removeEventListener("message", showError, false);

    processHide();
  }

  handleLoading() {
    this.processReady = true;

    processShow({ imageProcess: this.imageProcess, titleProcess: this.titleProcess, percentageProcess: this.percentageProcess, desProcess: this.desProcess });

    if (!this.setupMessageHandle) {
      this.setupMessageHandle = true;
      let t = this;
      window.addEventListener('message', function (e) {
        if (e.data != null && typeof e.data == "string") {
          if (e.data.indexOf('activeTab_') == 0) {
            t.activeTab = e.data.replace('activeTab_', '');
            if (t.activeTab == 'Summary') {
              t.activeTab = '';
            }
            localStorage.setItem('activeTab', t.activeTab);
          }
        }
      });
    }
  }
  public reportLoaded() {
    this.ready = true;
  }
  public onDateSelect(event) {
    // dispatchDateSelectChange({ ...event, ...{ element: "daily-report" } });
    // if (document.getElementById('analytics-data') != null) {
    //   document.getElementById('analytics-data').scrollLeft = 0;
    //   document.getElementById('analytics-data').scrollTop = 0;
    // }
    this.ready = true;
    let selectedDate = new Date(this.selectedDate.year, this.selectedDate.month - 1, this.selectedDate.day);
    let year = selectedDate.getFullYear();
    let month = selectedDate.getMonth();
    let date = selectedDate.getDate();
    localStorage.setItem('selectedDate', year + ',' + month + ',' + date);
    this.checkedReport = false;
    this.checkedSummary = false;
    this.ready = false;
    let day = this.selectedDate.year + '-' + (this.selectedDate.month < 10 ? '0' + this.selectedDate.month : this.selectedDate.month)
      + '-' + (this.selectedDate.day < 10 ? '0' + this.selectedDate.day : this.selectedDate.day);
    this.loadReportSummary(day);
    this.periodDay = 'Period : as of ' + `${this.selectedDate.year}/${this.selectedDate.month}/${this.selectedDate.day}`;

    // this.dailyReportUrl = this.sanitizer.bypassSecurityTrustResourceUrl(environment.dailyReportUrl.replace('{0}', date).replace('{1}', localStorage.getItem('accessToken')).replace('{2}', this.activeTab));
    //this.dailyReportHistUrl = this.sanitizer.bypassSecurityTrustResourceUrl(environment.dailyReportHistUrl.replace('{0}', day).replace('{1}', localStorage.getItem('accessToken')).replace('{2}', this.activeTab).replace('{3}', this.dataupdate));
    //this.bindIconProcess();
  }

  load() {
    //Wait for data check from indexeddb before calling script
    if (this.checkedSummary && this.checkedReport) {
      this._document.getElementById("analytics-data").innerHTML = '';
      AnalyticsHelper.loadScript(this._renderer2, this._document);
      this.handleLoading();
    }
    else {
      let t = this;
      setTimeout(() => {
        t.load()
      }, 100);
    }
  }

  public bindIconProcess() {
    this.processReady = false;
    var currentDate = new Date(this.selectedDate.year, this.selectedDate.month - 1, this.selectedDate.day);
    let startDate = new Date(this.selectedDate.year, this.selectedDate.month - 1, this.selectedDate.day);
    startDate.setDate(1);
    let today = this.selectedDate.year + (this.selectedDate.month > 9 ? '' : '0') + this.selectedDate.month +
      (this.selectedDate.day > 9 ? '' : '0') + this.selectedDate.day;
    let queryUrl = environment.snowflakeProxy + "?code=" + AnalyticsQueries.percentPerformance + "&date=" + today;
    // let startMonth = this.selectedDate.year + (this.selectedDate.month > 9 ? '' : '0') + this.selectedDate.month + '01';
    // let month = this.selectedDate.year + (this.selectedDate.month > 9 ? '' : '0') + this.selectedDate.month;
    // queryUrl = queryUrl.replace('{0}', startMonth).replace('{0}', startMonth).replace('{1}', today).replace('{2}', month);
    var accessToken = 'Bearer ' + localStorage.getItem('accessToken');
    let httpOptions: Object = {
      headers: new HttpHeaders().append('Authorization', accessToken),
      responseType: 'text'
    }
    this.http.get<any>(queryUrl, httpOptions)
      .subscribe(
        response => {
          let arr = tsvParse.tsvParse('act	id\n' + response);
          if (arr[0].act == '') {
            arr[0].act = 0;
          }
          if (arr.length > 1 && arr[1].act == '') {
            arr[1].act = 0;
          }
          let percent = Math.round((parseFloat(arr[0].act) / parseFloat(arr[1].act)) * 100);
          this.titleProcess = 'Progress from <b>' + startDate.getFullYear() + '/' + ("0" + (startDate.getMonth() + 1)).slice(-2) + '/' + "0" + startDate.getDate() + '</b> to <b>'
            + currentDate.getFullYear() + '/' + ("0" + (currentDate.getMonth() + 1)).slice(-2) + '/' + ("0" + currentDate.getDate()).slice(-2) + '</b><br/>' + (parseFloat(arr[0].act) / 1000000).toFixed(1) + ' MM / ' + (parseFloat(arr[1].act) / 1000000).toFixed(1) + ' MM';
          this.percentageProcess = percent;
          this.desProcess = '*This chart is using the most updated master data and transaction data from HANA';
          if (percent < 10) {
            this.imageProcess = 'assets/img/image_process/0_percent.png';
          } else if (percent < 20) {
            this.imageProcess = 'assets/img/image_process/10_percent.png';
          } else if (percent < 30) {
            this.imageProcess = 'assets/img/image_process/20_percent.png';
          } else if (percent < 40) {
            this.imageProcess = 'assets/img/image_process/30_percent.png';
          } else if (percent < 50) {
            this.imageProcess = 'assets/img/image_process/40_percent.png';
          } else if (percent < 60) {
            this.imageProcess = 'assets/img/image_process/50_percent.png';
          } else if (percent < 70) {
            this.imageProcess = 'assets/img/image_process/60_percent.png';
          } else if (percent < 80) {
            this.imageProcess = 'assets/img/image_process/70_percent.png';
          } else if (percent < 90) {
            this.imageProcess = 'assets/img/image_process/80_percent.png';
          } else if (percent < 100) {
            this.imageProcess = 'assets/img/image_process/90_percent.png';
          } else {
            this.imageProcess = 'assets/img/image_process/perfect_percent.png';
          };
          this.handleLoading();
        },
        error => {
          console.log(error);
        }
      );
  }

  downloadReport() {
    let date = this.selectedDate.year + '-' + (this.selectedDate.month < 10 ? '0' + this.selectedDate.month : this.selectedDate.month)
      + '-' + (this.selectedDate.day < 10 ? '0' + this.selectedDate.day : this.selectedDate.day);
    let queryUrl = environment.dailyReportDownload + "?date=" + date;
    let httpOptions: Object = {
      headers: new HttpHeaders().append('Authorization', 'Bearer ' + localStorage.getItem('accessToken')),
      responseType: 'text'
    }
    this.http.get<any>(queryUrl, httpOptions)
      .subscribe(
        response => {
          const a = document.createElement('a');
          a.href = response;
          a.download = ''; // browser sẽ tự lấy filename
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);

        },
        error => {
          console.log(error);
        }
      );
  }

  isChannelLv2(channelName: string) {
    return AnalyticsHelper.ChannelLv2().some((obj) => obj.channel === channelName && obj.level === 2 && channelName != 'Retail' && channelName != 'Food');
  }
  isChannelLv2RetailFood(channelName: string) {
    if (AnalyticsHelper.retailSaleDivisionChannel().some((obj) => obj.channel === channelName)
      || AnalyticsHelper.alcoholChannel().some((obj) => obj.channel === channelName)
      || AnalyticsHelper.FoodBranches().some((obj) => obj.name === channelName && obj.code !== 9400))
      return true;
    else
      return false;

  }
  loadReportSummary(selectedDate: any) {
    this.ready = true;
    let queryUrl = environment.dailyReportSummary + "?date=" + selectedDate;
    let httpOptions: Object = {
      headers: new HttpHeaders().append('Authorization', 'Bearer ' + localStorage.getItem('accessToken')),
      responseType: 'json'
    }
    this.http.get<any>(queryUrl, httpOptions)
      .subscribe(
        response => {
          this.dailyDataSummary = response
          this.dailyDataCCBJISalesByChannel = response.filter(item => item.name === 'CCBJI Sales').map(item => ({ ...item }));
          this.dailyDataCCBJISalesRetailCompany = response.filter(item => item.name === 'Retail Company').map(item => ({ ...item }));
          this.dailyDataCCBJISalesFoodServiceCompany = response.filter(item => item.name === 'Food Service Company By Headquarter').map(item => ({ ...item }));

          this.dailyDataCCBJISalesRetailCompanyTotal = response.filter(item => item.name === 'Retail Company Total').map(item => ({ ...item }));
          this.dailyDataCCBJISalesNationalSalesDivisionTotal = response.filter(item => item.name === 'National Sales Division').map(item => ({ ...item }));
          this.dailyDataCCBJISalesEastJapan = response.filter(item => item.name === 'National East Japan').map(item => ({ ...item }));
          this.dailyDataCCBJISalesMetropolitan = response.filter(item => item.name === 'National Metroppolitan').map(item => ({ ...item }));
          this.dailyDataCCBJISalesKansaiChubu = response.filter(item => item.name === 'National Kansai Chubu').map(item => ({ ...item }));
          this.dailyDataCCBJISalesKyushuChushikoku = response.filter(item => item.name === 'National Kyushu').map(item => ({ ...item }));
          this.dailyDataCCBJISalesRetailSalesDivisionTotal = response.filter(item => item.name === 'Retail Sales Division Total').map(item => ({ ...item }));
          this.dailyDataCCBJISalesEastJapanRetail = response.filter(item => item.name === 'Retail East Japan').map(item => ({ ...item }));
          this.dailyDataCCBJISalesMetropolitanRetail = response.filter(item => item.name === 'Retail Metropolitan').map(item => ({ ...item }));
          this.dailyDataCCBJISalesKansaiChubuRetail = response.filter(item => item.name === 'Retail Kansai Chubu').map(item => ({ ...item }));
          this.dailyDataCCBJISalesKyushuChushikokuRetail = response.filter(item => item.name === 'Retail Kyushu').map(item => ({ ...item }));
          this.dailyDataCCBJISaleseCommerceSalesTotal = response.filter(item => item.name === 'eCommerce Sale Total').map(item => ({ ...item }));
          this.dailyDataCCBJISalesFSCompanyTotal = response.filter(item => item.name === 'FS Company Total').map(item => ({ ...item }));
          this.dailyDataCCBJISalesFSCompanyFSAreaSalesTotal = response.filter(item => item.name === 'FS Area Sale Total').map(item => ({ ...item }));
          this.dailyDataCCBJISalesFSEastJapan = response.filter(item => item.name === 'FS East Japan').map(item => ({ ...item }));
          this.dailyDataCCBJISalesFSWestJapan = response.filter(item => item.name === 'FS West Japan').map(item => ({ ...item }));
          this.dailyDataCCBJISalesFSAreaOther = response.filter(item => item.name === 'FS Area Other').map(item => ({ ...item }));
          this.dailyDataCCBJISalesFSNationKamOther = response.filter(item => item.name === 'FS National KAM').map(item => ({ ...item }));
          
          this.ready = false;
        },
        error => {
          console.log(error);
        }
      );
  }

  isShowDownload(): boolean {

    const d = new Date(this.selectedDate.year, this.selectedDate.month - 1, this.selectedDate.day);
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);
    const isYesterday =
      d.getFullYear() === yesterday.getFullYear() &&
      d.getMonth() === yesterday.getMonth() &&
      d.getDate() === yesterday.getDate();
    const isFriday = d.getDay() === 5;
    const lastDay = new Date(d.getFullYear(), d.getMonth() + 1, 0);
    const isLastDay = d.getDate() === lastDay.getDate();

    return isFriday || isLastDay || isYesterday;
  }

  isNotShowSummary(): boolean {
    // const today = new Date(this.selectedDate.year, this.selectedDate.month - 1, this.selectedDate.day);
    // const cutoffDate = new Date(2026, 3, 1);
    // return today < cutoffDate;
    return false
  }

    removeLeadingPlus(value: any): string {
     return String(value ?? '')
    .trim()
    .replace(/^\+/, '')
    .replace(/,/g, '');
  }

  isNegativeAfterNormalize(value: any): boolean {
    const normalized = this.removeLeadingPlus(value);
    const num = Number(normalized);
    if(num > 3310 && num< 3321)
    {
      debugger
    }
    return !isNaN(num) && num >= 0;
  }
}